import axios from '../index';

export const requestNewestObservation = ({ patientId, userId = null }) =>
  axios.get(`/fhir/Observation`, {
    params: {
      subject: patientId,
      _sort: '-date',
      _count: 1,
      ...(userId && { performer: userId }),
    },
  });
